import React from "react";

const EquipmentAssets = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon" {...props}>
    <path
      d="M3.33334 18.3333C3.33334 14.6513 6.31811 11.6666 10 11.6666C13.6819 11.6666 16.6667 14.6513 16.6667 18.3333H15C15 15.5718 12.7614 13.3333 10 13.3333C7.23858 13.3333 5.00001 15.5718 5.00001 18.3333H3.33334ZM10 10.8333C7.23751 10.8333 5.00001 8.59575 5.00001 5.83325C5.00001 3.07075 7.23751 0.833252 10 0.833252C12.7625 0.833252 15 3.07075 15 5.83325C15 8.59575 12.7625 10.8333 10 10.8333ZM10 9.16658C11.8417 9.16658 13.3333 7.67492 13.3333 5.83325C13.3333 3.99159 11.8417 2.49992 10 2.49992C8.15834 2.49992 6.66668 3.99159 6.66668 5.83325C6.66668 7.67492 8.15834 9.16658 10 9.16658Z"
      fill="currentColor"
    />
  </svg>
);
export default EquipmentAssets;
